export const SET_EXPANDED_CAMPAIGNS = 'SET_EXPANDED_CAMPAIGNS';
export const SET_SELECTED_CAMPAIGNS = 'SET_SELECTED_CAMPAIGNS';
